"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.Details = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _nicbaseForms = require("nicbase-forms");

var _nicbaseTranslation = require("nicbase-translation");

var _alarmSection = _interopRequireDefault(require("./alarm-section"));

var _assetSection = _interopRequireDefault(require("./asset-section"));

var _driverSection = _interopRequireDefault(require("./driver-section"));

var _notificationSection = _interopRequireDefault(require("./notification-section"));

var _reportSection = _interopRequireDefault(require("./report-section"));

var _routeSection = _interopRequireDefault(require("./route-section"));

var _segmentsSection = _interopRequireDefault(require("./segments-section"));

var _tourDetailsSection = _interopRequireDefault(require("./tour-details-section"));

var _waypointsSection = _interopRequireDefault(require("./waypoints-section"));

require("./details-component.scss");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var Details = function Details(_ref) {
  var _tour$segments, _tour$report, _tour$report2;

  var tour = _ref.tour;
  var isDelayedAlarmsEnabled = tour.delayedStartLimitAlarm !== null || tour.delayedEndLimitAlarm !== null;
  var isEtaMonitoringEnabled = tour.etaProvider !== null;
  var areAlarmsEnabled = tour.alarms.length > 0;
  var isRouteMonitoringEnabled = tour.route && !!tour.route.id;
  var showTourDetailsSection = !!tour.name;
  var showWaypointsSection = true;
  var showRouteSection = tour.route && tour.route.id;
  var showAlarmSection = tour.alarms && tour.alarms.length > 0;
  var showSegmentsSection = ((_tour$segments = tour.segments) === null || _tour$segments === void 0 ? void 0 : _tour$segments.length) > 0;
  var showNotificationSection = isDelayedAlarmsEnabled || isEtaMonitoringEnabled || areAlarmsEnabled || isRouteMonitoringEnabled;
  var showReportSection = ((_tour$report = tour.report) === null || _tour$report === void 0 ? void 0 : _tour$report.recipients.length) > 0 || !((_tour$report2 = tour.report) !== null && _tour$report2 !== void 0 && _tour$report2.recipients.shareViaEmail);
  var showDriverSection = !!tour.driver;
  var showAssetSection = !!tour.assetId || !!tour.dataRequest;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "details-container"
  }, showTourDetailsSection && /*#__PURE__*/_react["default"].createElement(_nicbaseForms.SectionHeader, {
    title: /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
      id: "widgets.tourBoard.tourInformation",
      tagName: "span"
    })
  }, /*#__PURE__*/_react["default"].createElement(_tourDetailsSection["default"], {
    tour: tour
  })), showAssetSection && /*#__PURE__*/_react["default"].createElement(_nicbaseForms.SectionHeader, {
    title: /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
      id: "widgets.tourBoard.assetSection",
      tagName: "span"
    })
  }, /*#__PURE__*/_react["default"].createElement(_assetSection["default"], {
    tour: tour
  })), showWaypointsSection && /*#__PURE__*/_react["default"].createElement(_nicbaseForms.SectionHeader, {
    title: /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
      id: "widgets.tourBoard.tourSequence",
      tagName: "span"
    })
  }, /*#__PURE__*/_react["default"].createElement(_waypointsSection["default"], {
    tour: tour
  })), showRouteSection && /*#__PURE__*/_react["default"].createElement(_nicbaseForms.SectionHeader, {
    title: /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
      id: "widgets.tourBoard.routeMonitoring",
      tagName: "span"
    })
  }, /*#__PURE__*/_react["default"].createElement(_routeSection["default"], {
    tour: tour
  })), showSegmentsSection && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_nicbaseForms.SectionHeader, {
    title: /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
      id: "widgets.tourBoard.segments",
      tagName: "span"
    })
  }), /*#__PURE__*/_react["default"].createElement(_segmentsSection["default"], {
    tour: tour
  })), showAlarmSection && /*#__PURE__*/_react["default"].createElement(_nicbaseForms.SectionHeader, {
    title: /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
      id: "widgets.tourBoard.alarms",
      tagName: "span"
    })
  }, /*#__PURE__*/_react["default"].createElement(_alarmSection["default"], {
    tour: tour
  })), showNotificationSection && /*#__PURE__*/_react["default"].createElement(_nicbaseForms.SectionHeader, {
    title: /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
      id: "widgets.tourBoard.monitoring.notification",
      tagName: "span"
    })
  }, /*#__PURE__*/_react["default"].createElement(_notificationSection["default"], {
    tour: tour
  })), showReportSection && /*#__PURE__*/_react["default"].createElement(_nicbaseForms.SectionHeader, {
    title: /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
      id: "widgets.tourBoard.report",
      tagName: "span"
    })
  }, /*#__PURE__*/_react["default"].createElement(_reportSection["default"], {
    tour: tour
  })), showDriverSection && /*#__PURE__*/_react["default"].createElement(_nicbaseForms.SectionHeader, {
    title: /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
      id: "widgets.tourBoard.driver",
      tagName: "span"
    })
  }, /*#__PURE__*/_react["default"].createElement(_driverSection["default"], {
    tour: tour
  })));
};

exports.Details = Details;
Details.propTypes = {
  tour: _propTypes["default"].shape({
    assetId: _propTypes["default"].string,
    name: _propTypes["default"].string,
    dataRequest: _propTypes["default"].shape({}),
    route: _propTypes["default"].shape({
      id: _propTypes["default"].string
    }),
    driver: _propTypes["default"].shape({}),
    alarms: _propTypes["default"].arrayOf(_propTypes["default"].shape({
      id: _propTypes["default"].number.isRequired,
      type: _propTypes["default"].string
    })),
    delayedStartLimitAlarm: _propTypes["default"].string,
    delayedEndLimitAlarm: _propTypes["default"].string,
    segments: _propTypes["default"].arrayOf(_propTypes["default"].shape({})),
    wayPoints: _propTypes["default"].instanceOf(Object),
    report: _propTypes["default"].shape({
      recipients: _propTypes["default"].arrayOf(_propTypes["default"].string),
      shareViaEmail: _propTypes["default"].bool
    }),
    emailRecipients: _propTypes["default"].instanceOf(Object),
    smsRecipients: _propTypes["default"].instanceOf(Object),
    etaProvider: _propTypes["default"].string,
    showGeoInformationInReport: _propTypes["default"].bool
  }).isRequired
};
Details.defaultProps = {};
var _default = Details;
exports["default"] = _default;